import { faSlidersSimple } from "@jewlr/pro-light-svg-icons/faSlidersSimple"
import PropTypes from "prop-types"

import useCollection from "areas/collection/hoc/use-collection"
import withFilters from "areas/collection/hoc/with-filters"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const InternalFilterHeader = ({ clearAllTags, tags, toggleFilterModal }) => {
  const { data = {} } = useCollection()
  const { total_product_count } = data.pagination ?? {}

  return (
    <>
      <Divider className="mb-4" />
      <div className="flex items-center justify-between gap-24">
        <p className="leading-26 font-medium">
          {total_product_count} Product{total_product_count > 1 ? "s" : ""}
        </p>
        <div className="flex items-center gap-10">
          {tags.length > 0 && (
            <>
              <Button
                aria-label="Clear all filters"
                className="desktop:inline-flex hidden font-medium"
                data-cy="collection-filter-tag-clear-all"
                onClick={(e) => clearAllTags(e)}
                size="xs"
                underline
                variant="tertiary"
              >
                Clear Filters
              </Button>
              <span
                aria-label={`${tags.length} active filter${tags.length > 1 ? "s" : ""}`}
                className="bg-bg text-13 ml-6 rounded-md px-6 italic"
              >
                {tags.length}
              </span>
            </>
          )}
          {total_product_count > 0 && (
            <Button
              className="gap-6 font-medium"
              onClick={() => toggleFilterModal(true)}
              size="xs"
              underline
              variant="tertiary"
            >
              Filter & Sort
              <FontAwesomeIcon icon={faSlidersSimple} />
            </Button>
          )}
        </div>
      </div>
      <Divider className="mt-4" />
    </>
  )
}

InternalFilterHeader.propTypes = {
  clearAllTags: PropTypes.func,
  tags: PropTypes.array,
  toggleFilterModal: PropTypes.func,
}

const FilterHeader = withFilters(InternalFilterHeader)

export default FilterHeader
